import { exists } from '@engine/lib/utility/exists';
var referenceIdField = '';
var previousReferenceIdValue = '';
var referenceIdContainer = '';
var remainingAmountPlaceholder = '-.--';
var initialRemainingAmount = '0.00';
var remainingAmount = initialRemainingAmount;
var trxsWithRemainingAmount = ['capture', 'refund', 'partial_reversal', 'sale', 'sale3d', 'invoice_refund', 'invoice_capture', 'fashioncheque', 'intersolve', 'container_store', 'async_refund'];

function findRemainingAmountTransactionsForm() {
  var selectors = trxsWithRemainingAmount.map(function (trx_type) {
    return ['#new_', trx_type, '_transaction'].join('');
  });
  var selector = selectors.join(',');
  return $(selector);
}

function findRemainingAmountReferenceIdFields() {
  var selectors = trxsWithRemainingAmount.map(function (trx_type) {
    return ['#', trx_type, '_transaction_reference_id'].join('');
  });
  var selector = selectors.join(',');
  return $(selector);
}

function setRemainingAmount(amount) {
  remainingAmount = amount;
}

function selectCustomAmountOption() {
  $('#input_amount_custom').prop('checked', true);
}

function selectRemainingAmountOption() {
  $('#input_amount_remaining').prop('checked', true);
}

function changeAmountInRemainingValueOptionLabel(amount) {
  $('#remaining_amount_value').text(' (' + amount + ')');
}

function removeErrorFromReferenceIdField() {
  referenceIdContainer.removeClass('fieldWithErrors');
}

function addErrorOnReferenceIdField() {
  referenceIdContainer.addClass('fieldWithErrors');
}

function populateAmountFields(amount) {
  var wholeAmountField = $('#whole_amount');
  var decimalAmountField = $('#decimal_amount');
  wholeAmountField.val(amount.split('.')[0]);
  decimalAmountField.val(amount.split('.')[1]);
}

function makeRemainingAmountRequest(onSuccess, onMissingAmount) {
  var transactionType = findRemainingAmountTransactionsForm().attr('action').split('/').pop();
  $.ajax({
    type: 'POST',
    url: '/virtual_terminal/fetch_remaining_amount',
    data: {
      reference_id: referenceIdField.val(),
      transaction_type: transactionType
    },
    success: function success(data) {
      if (data.remaining_amount_missing === true) {
        if (typeof onMissingAmount !== 'undefined') {
          onMissingAmount();
        }
      } else {
        onSuccess(data);
      }
    }
  });
}

function synchronizeAmountInputs() {
  if (remainingAmount === '0.00' || $('#whole_amount').val() !== remainingAmount.split('.')[0] || $('#decimal_amount').val() !== remainingAmount.split('.')[1]) {
    selectCustomAmountOption();
  } else {
    selectRemainingAmountOption();
  }
}

function populateRemainingAmountByReferenceId() {
  makeRemainingAmountRequest(function (data) {
    setRemainingAmount(data.remaining_amount);
    removeErrorFromReferenceIdField();
    populateAmountFields(data.remaining_amount);
    changeAmountInRemainingValueOptionLabel(data.remaining_amount);
    synchronizeAmountInputs();
  }, function () {
    setRemainingAmount(initialRemainingAmount);
    addErrorOnReferenceIdField();
    selectCustomAmountOption();
    changeAmountInRemainingValueOptionLabel(remainingAmountPlaceholder);
    synchronizeAmountInputs();
  });
}

function listenForInputAmountOptionChange() {
  $('.input_amount_radio').on('change', function () {
    var selectedOption = $(this).val();

    if (selectedOption === 'remaining' && referenceIdField.val().length === 0) {
      addErrorOnReferenceIdField();
      selectCustomAmountOption();
      return false;
    }

    if (selectedOption === 'custom') {
      removeErrorFromReferenceIdField();
      populateAmountFields('0.00');
    } else if (selectedOption === 'remaining') {
      populateRemainingAmountByReferenceId();
    }
  });
}

function listenForReferenceIdFieldChange() {
  referenceIdField.on('focus', function () {
    previousReferenceIdValue = $(this).val();
  });
  referenceIdField.on('blur', function () {
    var selectedOption = $('.input_amount_radio:checked').val();

    if (previousReferenceIdValue !== referenceIdField.val()) {
      makeRemainingAmountRequest(function (data) {
        setRemainingAmount(data.remaining_amount);
        changeAmountInRemainingValueOptionLabel(data.remaining_amount);
        synchronizeAmountInputs();
      }, function () {
        setRemainingAmount(initialRemainingAmount);
        changeAmountInRemainingValueOptionLabel(remainingAmountPlaceholder);
        synchronizeAmountInputs();
      });

      if (selectedOption === 'remaining') {
        selectCustomAmountOption();
      }
    }
  });
}

function listenForInputAmountChange() {
  $('#whole_amount, #decimal_amount').on('change keyup', function () {
    synchronizeAmountInputs();
  });
}

function populateRemainingAmountValueLabel() {
  if (referenceIdField.length === 0) {
    return false;
  }

  makeRemainingAmountRequest(function (data) {
    setRemainingAmount(data.remaining_amount);
    changeAmountInRemainingValueOptionLabel(data.remaining_amount);
    synchronizeAmountInputs();
  }, function () {
    setRemainingAmount(initialRemainingAmount);
    synchronizeAmountInputs();
  });
}

function loadRemainingAmount() {
  var transactionsForm = findRemainingAmountTransactionsForm();

  if (transactionsForm.length === 0) {
    return false;
  }

  referenceIdField = findRemainingAmountReferenceIdFields();
  referenceIdContainer = referenceIdField.parent(); // The new Sales Operator template does not support reference_id

  if (!exists(referenceIdField)) {
    return false;
  }

  if (referenceIdField.val().length !== 0) {
    populateRemainingAmountValueLabel();
  }

  synchronizeAmountInputs();
  listenForInputAmountOptionChange();
  listenForReferenceIdFieldChange();
  listenForInputAmountChange();
}

var Amount = {
  loadRemainingAmount: loadRemainingAmount
};
export default Amount;